import { useMutation } from '@tanstack/react-query';
import { ConvertedReferralCampaign } from '@demind-inc/core';

import { accountApi } from '../api';

interface UseSyncSuccessStripePaymentParams {
  userId: string;
  sessionId: string;
  referral?: ConvertedReferralCampaign;
  discount?: object;
}

export function useSyncSuccessStripePayment() {
  const syncSuccessPayment = useMutation({
    mutationFn: ({ userId, sessionId, referral, discount }: UseSyncSuccessStripePaymentParams) => {
      return accountApi.syncSuccessStripePayment(userId, {
        sessionId,
        referral,
        discount,
      });
    },
  });

  return {
    syncSuccessStripePayment: syncSuccessPayment.mutateAsync,
    ...syncSuccessPayment,
  };
}
